<!-- <div id="loading" *ngIf="loading">
  <img src="../../../assets/images/icon_gier.png" alt="Loading" />
</div> -->

<div id="map" class="map"></div>